import {Pipe, PipeTransform} from "@angular/core";

import moment from "moment-timezone";

/*
 * Time helper using momentjs
 * Usage:
 *   timestamp | moment:'DD.MM.YYYY'
 * Defaults to 'L' - locale ie. '01/24/2016'
 */
@Pipe({name: 'moment'})
export class MomentPipe implements PipeTransform {
  transform(value:number, args:string) : any {
    let date = moment(value);

    if (date.isValid()) {
      return date.format(args || 'L');
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/moment.pipe.ts